import { render } from "./shopStatisticsTotal.vue?vue&type=template&id=4859871c"
import script from "./shopStatisticsTotal.vue?vue&type=script&lang=js"
export * from "./shopStatisticsTotal.vue?vue&type=script&lang=js"

import "./shopStatisticsTotal.vue?vue&type=style&index=0&id=4859871c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__